import { useEffect, useState } from "react";
import {
    Tabs,
    Table,
    Button,
    Form,
    Input,
    Select,
    Checkbox,
    Modal,
    message,
    Row,
    Col,
    Typography,
    Spin,
    Tooltip,
    Popconfirm
} from "antd";
import { DeleteOutlined, PlusOutlined, EditOutlined } from "@ant-design/icons";
import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";
import FiltersDynamic from "../Components/FiltersDynamicComponent";

const { TabPane } = Tabs;
const { Title } = Typography;



const ObjectRules = ({ object }) => {
    const [fields, setFields] = useState([]);
    const [activeTab, setActiveTab] = useState("alert");
    const [modalVisible, setModalVisible] = useState(false); // ✅ modal state
    const [lookupOptions, setLookupOptions] = useState([]);
    const [logic, setLogic] = useState("");
    const [operator, setOperator] = useState("AND");
    const [valueOperator, setValueOperator] = useState("");
    const [filters, setFilters] = useState([{ 1: { field: '', value: '', displayValue: '' } }]);
    const [alertRules, setAlertRules] = useState([]);
    const [currentRule, setCurrentRule] = useState();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        const fetchfields = async () => {
            try {
                const apiService = new ApiService(
                    `${BASE_URL}/mt_fields/object/${object.name}`,
                    {},
                    "GET"
                );
                const response = await apiService.makeCall();
                setFields(response);
            } catch (error) {
                console.error(error);
            }
        };
        fetchfields();
    }, [object]);

    useEffect(() => {

        fetchRules();
    }, []);

    const fetchRules = async () => {
        try {
            setLoading(true);
            const apiService = new ApiService(
                `${BASE_URL}/rules/${object.name}`,
                {},
                "GET"
            );
            const response = await apiService.makeCall();
            const alertRules = (response.rules || []).filter(
                (rule) => rule.rule_type === "alert"
            );
            setAlertRules(alertRules);
        } catch (error) {

        }
        finally {
            setLoading(false);   // 👈 ensures spinner stops
        }
    };


    // --- filter transformation ---
    const transformFilters = (filters) => {
        return filters.reduce((acc, filter, index) => {
            if (filter.field) {
                acc[index + 1] = {
                    field: filter.field,
                    value:
                        filter.operator && filter.value === ""
                            ? { [filter.operator]: "" }
                            : filter.value,
                };
            }
            return acc;
        }, {});
    };

    // ✅ Open modal for new rule
    const openNewModal = () => {
        form.setFieldValue(null);
        setCurrentRule(null);
        setFilters([]);
        setOperator([]);
        setLogic('');
        setLookupOptions([]);
        setModalVisible(true);
    };



    // New function to fetch lookup records based on existing filters
    const fetchLookupRecordsForExistingFilters = (existingFilters) => {
        existingFilters.forEach(filter => {
            const selectedField = fields.find(field => field.name === filter.field?.replace('_id', ''));
            if (selectedField && selectedField.type === 'lookup') {
                fetchLookupRecords(selectedField.parent_object_name); // Fetch records for lookup fields
            }
        });
    };
    // Function to fetch records for the lookup field
    const fetchLookupRecords = async (objectName) => {
        try {
            const apiServiceForRecords = new ApiService(
                `${BASE_URL}/fetch_records/${objectName}`,
                { 'Content-Type': 'application/json' },
                'GET'
            );
            const response = await apiServiceForRecords.makeCall();
            // Assuming response is an array of records with _id and Name fields
            const records = response?.records?.map(record => ({
                value: record._id, // Set _id as value
                label: record.Name, // Set Name as label
            }));
            setLookupOptions(records); // Set options for the lookup field
        } catch (error) {
            const errorMessage = error && typeof error === 'object'
                ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
                : 'Failed to save field due to an unknown error';
            message.error(errorMessage);
        }
    };
    // ✅ Save rule (new or edit)
    const handleSave = async (values) => {

        try {

            setLoading(true);

            const updatedFilters = transformFilters(filters);
            console.log('updarted filters', updatedFilters);
            console.log('values coming up', values);

            const body = {

                "rule": {
                    "object_name": object.name,
                    "rule_type": "alert",
                    "error_message": values.error_message,
                    "filters": updatedFilters,
                    "is_active": values.is_active,
                    "logic_string": logic,
                    "alert_type": values.alert_type
                }

            }


            if (currentRule?._id) {
                const apiService = new ApiService(
                    `${BASE_URL}/edit_rule/${currentRule._id}`,
                    { 'Content-Type': 'application/json' },
                    'PATCH',
                    body
                );
                const response = await apiService.makeCall();
                message.success("Rule Updated Successfully");
            }
            else {

                console.log('in the else');

                const apiService = new ApiService(
                    `${BASE_URL}/create_rule`,
                    { 'Content-Type': 'application/json' },
                    'POST',
                    body
                );
                const response = await apiService.makeCall();

                console.log(response);

                message.success("Rule created successfullly");
            }

            fetchRules();

        }
        catch (error) {

            const errorMessage = error && typeof error === 'object'
                ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
                : 'Failed to save field due to an unknown error';
            message.error(errorMessage);

        } finally {
            setLoading(false);
            setCurrentRule(null);
            setFilters([]);
            setLogic('');
            setOperator(null);
            setLookupOptions(null);
            setModalVisible(false);
        }
    };

    const handleEditAlertRule = (rule) => {

        const existingFilters = rule.filters
            ? Object.entries(rule.filters).map(([key, { field, value }]) => {
                let operator = '';
                let actualValue = '';
                if (typeof value === 'object' && value !== null) {
                    operator = Object.keys(value)[0]; // Extract operator ("$lt")
                    actualValue = value[operator]; // Extract the actual value (20)
                } else {
                    actualValue = value;
                }
                let op = '';
                if (operator !== '') {
                    try {
                        setValueOperator(operator);
                        op = operator;
                    } catch (error) {
                        // Handle the error gracefully
                        setValueOperator(''); // or any default value
                    }
                } else {
                    op = '';
                }
                return {
                    field,
                    value: value,
                    displayValue: actualValue,
                    operator: op
                };
            })
            : [{ field: '', value: '', operator: '' }];
        fetchLookupRecordsForExistingFilters(existingFilters); // Fetch lookup records for existing filters
        setFilters(existingFilters);
        setLogic(rule.logic_string);
        setCurrentRule(rule);
        form.setFieldsValue(rule);
        setModalVisible(true);


    }

    const handleDeleteAlertRule = async (rule) => {

        try {
            setLoading(true);
            const apiServiceDelete = new ApiService(
                `${BASE_URL}/delete_rule/${rule._id}`,
                { 'Content-Type': 'application/json' },
                'DELETE'
            );
            const response = await apiServiceDelete.makeCall();
            message.success("Rule deleted successfully");
            fetchRules();
        }
        catch (error) {
            const errorMessage = error && typeof error === 'object'
                ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
                : 'Failed to save field due to an unknown error';
            message.error(errorMessage);

        }

    }

    // ✅ Table config
    const columns = [
        { title: "Error Message", dataIndex: "error_message" },
        {
            title: "Filters",
            dataIndex: "filters",
            render: (filters) => {
                if (filters && typeof filters === "object") {
                    return Object.entries(filters)
                        .map(
                            ([key, { field, value }]) =>
                                `${key}: ${field} : ${JSON.stringify(value)}`
                        )
                        .join(", ");
                }
                return "";
            },
        },
        {
            title: "Active",
            dataIndex: "is_active",
            render: (value) => <Checkbox checked={value} disabled />,
        },
        { title: "Alert Type", dataIndex: "alert_type" },
        {
            title: "Actions",
            key: 'operation',
            render: (_, rule) => (
                <>
                    <Tooltip title="Edit">
                        <EditOutlined
                            onClick={(e) => {
                                e.stopPropagation();  // prevent triggering parent row events
                                handleEditAlertRule(rule);
                            }}
                            style={{ marginRight: 5, fontSize: '12px', cursor: 'pointer' }}
                        />
                    </Tooltip>

                    <Tooltip>
                        <Popconfirm
                            title="Are you sure you want to delete this item?"
                            okText="Yes"
                            cancelText="No"
                            onConfirm={(e) => {
                                e?.stopPropagation(); // prevent name click
                                handleDeleteAlertRule(rule);
                            }}
                            onCancel={(e) => {
                                e?.stopPropagation(); // ALSO stop propagation on "No"
                            }}
                        >

                            <DeleteOutlined
                                onClick={(e) => e.stopPropagation()} // prevent link from triggering
                                style={{ color: 'red', marginRight: 5, fontSize: '12px', cursor: 'pointer' }}
                            />
                        </Popconfirm>
                    </Tooltip>

                </>
            ),
        },
    ];

    return (
        <Tabs activeKey={activeTab} onChange={setActiveTab}>
            <TabPane tab="Alert Rules" key="alert">
                <Row justify="space-between" align="middle" style={{ marginBottom: 10 }}>
                    <Col>
                        <Title level={4} >Create Alert Rules</Title>
                    </Col>
                    <Col>
                        <Button type="primary" onClick={openNewModal}>
                            New
                        </Button>
                    </Col>
                </Row>

                <Spin spinning={loading}>
                    <Table dataSource={alertRules} columns={columns} rowKey={(r, i) => i} />
                </Spin>

                {/* ✅ Modal for New/Edit */}
                <Modal
                    title={currentRule !== null ? "Edit Rule" : "New Rule"}
                    open={modalVisible}
                    onCancel={() => setModalVisible(false)}
                    zIndex={1002}   // higher than sidebar
                    onOk={() => form.submit()}
                >
                    <Spin spinning={loading}>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={handleSave}
                        >

                            {/* Filters */}
                            <Form.Item  >
                                <FiltersDynamic
                                    fields={fields}
                                    filters={filters}
                                    setFilters={setFilters}
                                    logic={logic}
                                    setLogic={setLogic}
                                    setValueOperator={setValueOperator}
                                    valueOperator={valueOperator}
                                    fetchLookupRecordsForExistingFilters={() => fetchLookupRecordsForExistingFilters()}
                                    fetchLookupRecords={() => fetchLookupRecords()}
                                    lookupOptions={lookupOptions}
                                />
                            </Form.Item>


                            {/* Error Message */}
                            <Form.Item name="error_message" label="Error Message" rules={[{ required: true }]}>
                                <Input

                                    placeholder="Enter error message"

                                />
                            </Form.Item>

                            {/* Alert Type */}
                            <Form.Item name="alert_type" label="Alert Type" rules={[{ required: true }]}>
                                <Select

                                    placeholder="Select Alert type"
                                    options={[
                                        { value: "error", label: "error" },
                                        { value: "warning", label: "warning" },
                                        { value: "info", label: "info" },
                                        { value: "success", label: "success" },
                                    ]}
                                />
                            </Form.Item>

                            {/* Active */}
                            <Form.Item name="is_active" label="Active" valuePropName="checked"
                            >
                                <Checkbox >
                                    Active
                                </Checkbox>
                            </Form.Item>

                        </Form>
                    </Spin>
                </Modal>

            </TabPane>

            <TabPane tab="Validation Rules" key="validation">
                <p>Validation rules UI will come here…</p>
            </TabPane>
        </Tabs>
    );
};

export default ObjectRules;
